<template>
  <div>
    <Header />
    <ApplicationForm
      :application="application"
      :onValueChanged="onValueChanged"
      :addAdditionalSectionThree="addAdditionalSectionThree"
      :removeSectionThree="removeSectionThree"
      :addAdditionalSectionFour="addAdditionalSectionFour"
      :removeSectionFour="removeSectionFour"
      :addAdditionalImage="addAdditionalImage"
      :removeAdditionalImage="removeAdditionalImage"
      :error="error"
    />
    <Footer :onSubmit="submitApplication" />
  </div>
</template>

<script>
import Footer from "@/components/Application/Footer";
import ApplicationForm from "@/components/Application/Form";
import Header from "@/components/Application/Header";
import { Application } from "@/typings/application";

export default {
  name: "application",
  components: {
    ApplicationForm,
    Footer,
    Header
  },
  data() {
    return {
      application: new Application(),
      error: null
    };
  },
  methods: {
    onValueChanged(section, name, value) {
      this.$set(this.application[section], name, value);
    },
    addAdditionalSectionThree() {
      this.application.addAdditionalSectionThree();
    },
    removeSectionThree(index) {
      this.application.removeAdditionalSectionThree(index - 1);
    },
    addAdditionalSectionFour() {
      this.application.addAdditionalSectionFour();
    },
    removeSectionFour(index) {
      this.application.removeAdditionalSectionFour(index - 1);
    },
    addAdditionalImage() {
      this.application.addAdditionalImage();
    },
    removeAdditionalImage(index) {
      this.application.removeAdditionalImage(index);
    },
    async submitApplication() {
      if (this.application.canSubmit) {
        try {
          let alert = this.$swal({
            title: "Submitting applications...",
            type: "info",
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            allowEnterKey: false
          });
          await this.application.submit();
          alert.close();
          this.$router.push("/thanks");
        } catch (error) {
          this.$swal({
            title: "Unable to Submit Your Application",
            text:
              "An unexpected error was encountered while uploading application.",
            type: "error"
          });
        }
      } else {
        this.error = "Missing information!";
        this.moveViewToSectionOne();
      }
    },
    moveViewToSectionOne() {
      window.location.href = "#section1";
      this.$router.push("/");
    }
  }
};
</script>

<style></style>
